import React, { Component, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { openPopup } from "../Modal/action";
import { getMenu } from "../../../actions";
import { getRouting, getCurrentYear } from "../../../../utils/common";
import "./style_new.scss";
import { browserName } from 'react-device-detect';

const Footer = (props) => {
  const { getMenus, footerlinks } = props;
  const handleRelode = () => {
    window.scrollTo(0, 0);
  };

  //footeracord start
  const [selected, setSelected] = useState(0);
  const [isDesktop, setIsDesktop] = useState(true);
  const [checkAppBrowser, setcheckAppBrowser] = useState('');
  const [scrollHeight, setScrollHeight] = useState(0);

  useEffect(() => {
    const handleWindowSizeChange = () => {
      setIsDesktop(window.innerWidth > 767);
    };

    window.addEventListener('resize', handleWindowSizeChange);
    handleWindowSizeChange(); // Call the function initially to set the initial state

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const wrapper = document.getElementsByClassName('wrapper')[0];
      if (wrapper) {
        const scrollPosition = Math.floor(window.scrollY);
        setScrollHeight(scrollPosition);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if(browserName && browserName.includes('Safari')){
      setcheckAppBrowser('IOS');
    }    
  }, [browserName]);

  const toggle = (index) => {
    if (selected === index) {
      return setSelected(null);
    }
    setSelected(index);
  };

  //footeracord end
  return (
    <>
      <div className="mainvission vissionsec">
        {/* <div className="vissionsec"> */}
          <div className="bluebg">
            <p><span>Mission:</span> To be the wealth creator for every Indian</p>
          </div>
          <div className="redbg">
            <p><span>Vision:</span> To be the most respected asset manager in the world</p>
          </div>
        {/* </div> */}
      </div>
      <section className="subFooter">
        <div className="container">
          <div className="d-flex">
            <div className="footernew">
              <div className="social_icons d-flex">
                <div className="me-5">
                  <p className="p_sec mb-3">Download our apps</p>
                  <ul className="d-flex ps-0">
                    <li>
                      {isDesktop && (
                         <a href={checkAppBrowser == 'IOS' ? 'https://apps.apple.com/in/app/hdfc-mutual-fund/id1380088205':'https://play.google.com/store/apps/details?id=com.hdfcfund.investor'} target="_blank" className="text-center" aria-label={checkAppBrowser === 'IOS' 
                          ? 'Download HDFC Mutual Fund app from Apple App Store' 
                          : 'Download HDFC Mutual Fund app from Google Play Store'}>
                          <img
                            src="/images/New/investorapp.svg"
                            alt="appStore icon"
                            width="62"
                            height="62"
                            loading="lazy"
                          />
                          <p className="apptext">HDFC Mutual Fund</p>
                        </a>
                      )}
                      {isDesktop == false && (
                        <a href="https://investor-web.hdfcfund.com/deeplinks/dashboard" className="text-center" aria-label="Go to HDFC Mutual Fund dashboard">
                          <img
                            src="/images/New/investorapp.svg"
                            alt="googlePlay icon"
                            width={50}
                            height={50}
                            loading="lazy"
                          />
                          <p className="apptext">HDFC Mutual Fund</p>
                        </a>
                      )}
                    </li>
                    <li>
                      {isDesktop && (
                        <a href={checkAppBrowser == 'IOS' ? 'https://apps.apple.com/in/app/hdfc-mf-online-partners/id1335989019':'https://play.google.com/store/apps/details?id=com.hdfc.mf'} target="_blank" aria-label={checkAppBrowser === 'IOS' 
                          ? 'Download HDFC MF app from Apple App Store' 
                          : 'Download HDFC MF app from Google Play Store'}>
                          <img
                            src="/images/New/HDFC-Product.svg"
                            alt="googlePlay icon"
                            width="62"
                            height="62"
                            loading="lazy"
                          />
                        </a>
                      )}
                      {isDesktop == false && (
                        <a href="https://distributor.hdfcfund.com/deeplinks/dashboard" className="ms-3" aria-label="Go to HDFC dashboard">
                          <img
                            src="/images/New/HDFC-Product.svg"
                            alt="googlePlay icon"
                            width={50}
                            height={50}
                            loading="lazy"
                          />
                        </a>
                      )}
                    </li>
                  </ul>
                  <p className="psize">Available on Android & IOS</p>
                </div>
              </div>

              <div className="addressdiv my-4">
                <p className="p_sec mb-3">Address</p>
                <p className="addresstext">HDFC House, House, 2nd Floor, <br/>165-166, 169, HT Parekh Marg,
                <br/>Backbay Reclamation, Churchgate, <br/>Mumbai, Maharashtra 400020
                </p>
              </div>
            </div>

            {isDesktop && (
              // <div className="plainRow">
                <div className="row plainRow">
                  {getMenus &&
                    getMenus.map((footer, index) => (
                      <div className="col-md-3">
                        <ul className="pages_list">
                          {footer && footer.routeConstant == null && footer.linkUrl == '/' ?  (
                            <li>
                            <p className="p_promary mb-3">{footer.linkName} </p>
                            </li>
                          ) : (
                            <li>
                            <Link
                              to={getRouting(footer.routeConstant)}
                              onClick={handleRelode}
                            >
                              <p className="p_promary mb-3">
                                {footer.linkName} 
                              </p>
                            </Link>
                            </li>
                          )}

                          {footer &&
                            footer.childrens.map((footerChild, index) => (
                              footerChild && footerChild.routeConstant == null && footerChild.linkUrl == '/' ? (
                                <li>{footerChild.linkName} </li>
                              ) : (
                                footerChild && footerChild.routeConstant ? (
                                <li>
                                  <Link
                                    to={getRouting(footerChild.routeConstant)}
                                    onClick={handleRelode}
                                  >
                                    {footerChild.linkName} 
                                  </Link>
                                </li>
                                ) : (
                                  <li><a href={footerChild.linkUrl}>{footerChild.linkName} </a></li>
                                )
                              )
                            ))}
                        </ul>
                      </div>
                    ))}
                </div>
               // </div> 
            )}
          </div>
          <div className="d-md-flex">
            <div className="footercontact mb-md-2 mb-3">
              <p className="p_sec mb-3">Contact us</p>
              {/* <div className="d-flex"> */}
                <a href="tel:180030106767" className="me-3"><img src="/images/New/calling.svg" width={32} height={32} alt="calling" /></a>

                <a href="mailto:hello@hdfcfund.com" className="me-3"><img src="/images/New/mail.svg" width={32} height={32} alt="Mail" /></a>

                <a href="https://api.whatsapp.com/send/?phone=8270682706&text=Hi&app_absent=0" className="me-3"><img src="/images/New/whats-app.svg" width={32} height={32} alt="whats app" /></a>

                <a href="/contact-us/visit-us" className="me-3"><img src="/images/New/location.svg" width={32} height={32} alt="location" /></a>
              {/* </div> */}
            </div>
            <div className="followus mb-2">
              {/* <img className="custom-size" src="/images/New/footer-logo.svg" alt="" /> */}
              {/* <div> */}
                <p className="p_sec mb-3">Follow Us</p>
                <div className="d-flex ps-0 socialicons">
                  <a
                    href="https://twitter.com/hdfcmf"
                    target="_blank"
                    className="me-1"
                    rel="nofollow"
                  >
                    <img
                      src="/images/New/footer-x.svg"
                      alt="twitter icon"
                      width={30}
                      height={30}
                      loading="lazy"
                      className="x-light"
                    />
                    <img
                      src="/images/New/darkmodex.png"
                      alt="twitter icon"
                      width={30}
                      height={30}
                      loading="lazy"
                      className="x-dark"
                    />
                  </a>
                  <a
                    href="https://www.facebook.com/hdfcmutualfund"
                    target="_blank"
                    className="me-1"
                    rel="nofollow"
                  >
                    <img
                      src="/images/New/footer-fb.svg"
                      alt="facebook icon"
                      width={30}
                      height={30}
                      loading="lazy"
                    />
                  </a>
                  <a
                    href="https://www.instagram.com/hdfcmf"
                    target="_blank"
                    className="me-1"
                    rel="nofollow"
                  >
                    <img
                      src="/images/New/Footer-instagram.svg"
                      alt="instagram icon"
                      width={30}
                      height={30}
                      className="radius"
                      loading="lazy"
                    />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/hdfc-mutual-fund/"
                    target="_blank"
                    className="me-1"
                    rel="nofollow"
                  >
                    <img
                      src="/images/New/footer-linkedin.svg"
                      alt="linkedin icon"
                      width={30}
                      height={30}
                      className="radius"
                      loading="lazy"
                    />
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCiuV2NCrpHzhQogNvK1FZ_A"
                    target="_blank"
                    className="me-1"
                    rel="nofollow"
                  >
                    <img
                      src="/images/New/footer-yt.svg"
                      alt="youtube icon"
                      width={30}
                      height={30}
                      loading="lazy"
                    />
                  </a>
                </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      </section>
      {isDesktop == false && (<section className="sub-footer-mobile  d-md-none">
        <div className="container">
          <div className="accordion plainRow footeracord">
            {getMenus &&
              getMenus.map((footers, index) => (
                <div className="item">
                  <div className="title" onClick={() => toggle(index)}>
                    <h2>{footers.linkName}</h2>
                    {selected === index ? (
                        <img
                          className="rotate"
                          src="/images/New/minus-img.svg"
                          width={20}
                          height={20}
                          alt="minus icon"
                        />
                    ) : (
                        <img
                          className="rotate"
                          src="/images/New/red-plus.svg"
                          width={20}
                          height={20}
                          alt="plus icon"
                        />
                    )}
                  </div>
                  <div
                    className={selected === index ? "content show" : "content"}
                  >
                    <ul>
                      {footers &&
                        footers.childrens.map((footerChilds, index) => (
                          footerChilds && footerChilds.routeConstant ?
                          <li>
                            <Link
                              to={getRouting(footerChilds.routeConstant)}
                              onClick={handleRelode}
                            >
                              {footerChilds.linkName}
                            </Link>
                          </li>
                          : (
                            <li><a href={footerChilds.linkUrl} rel="nofollow">{footerChilds.linkName}</a></li>
                          )
                        ))}
                    </ul>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>)}
      <footer id="footerID">
        {scrollHeight >= 240 && (<div className="container">
          <div className="secoundryFooter">
            {footerlinks && footerlinks.map((data,index)=> (
              data.value && data.value.length > 0 && (
              <div className="groupWebsiteLinks" key={index}>
                {isDesktop &&(<p className="groupwebsite">{data.title}</p>)}
                <div className="d-flex flex-wrap">
                {isDesktop == false &&(<p className="groupwebsite">{data.title}</p>)}
                  {data && data.value && data.value.map((subdata,subindex)=> (
                    data && data.title && data.title == "HDFC Group Websites:" ? 
                    <a href={subdata.url} className="fs14" rel="nofollow" key={subindex} target="_blank">
                      {subdata.title}
                    </a> :
                    <a href={subdata.url} className="fs14" key={subindex}>
                      {subdata.title}
                    </a>
                  ))}
                  {
                    data && data.title == "Most Searched Funds:" ? 
                    <a
                    href="/product-solutions"
                    className="fs14"
                    >
                      <span className="viewallbtn">View All</span>
                    </a> : ""
                  }
                </div>
              </div>
            )))}
            <hr className="separator d-none d-md-block" />
            <div className="d-md-flex justify-content-between align-items-center">
              <p className="text-center pt-2">
                MUTUAL FUND INVESTMENTS ARE SUBJECT TO MARKET RISKS, READ ALL
                SCHEME RELATED DOCUMENTS CAREFULLY
              </p>
              <hr className="separator d-md-none d-block" />
              <p className="copyRight pt-2"><span className="fw-bold">©</span>Copyright {getCurrentYear()}. All rights reserved.</p>
            </div>
          </div>
        </div>)}
      </footer>
    </>
  );
};

const mapStateToProps = (state) => ({
  getMenus: state.commonContent.menu.footerMenu,
  footerlinks: state.commonContent.menu.footerlinks,
});

const mapDispatchToProps = (dispatch) => ({
  getMenu: bindActionCreators(getMenu, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
